import axios from "axios";

const BACKEND_DEFAULT_BASE_URL = "http://localhost:3010/api";

function getBaseUrl() {
  const envBaseRaw = process.env.REACT_APP_API_BASE_URL;
  const envBase = envBaseRaw && envBaseRaw.trim() ? envBaseRaw.trim() : null;
  if (envBase) return envBase;
  if (typeof window !== "undefined") return `${window.location.origin}/api`;
  return BACKEND_DEFAULT_BASE_URL;
}

export function getBackendOrigin() {
  return getBaseUrl().replace(/\/api\/?$/, "");
}

const api = axios.create({
  baseURL: getBaseUrl(),
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");
  if (token) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

api.interceptors.response.use(
  (res) => res,
  async (error) => {
    const status = error?.response?.status;

    // If token is missing/invalid/expired, force re-login.
    if (status === 401) {
      localStorage.removeItem("token");
      localStorage.removeItem("user");
      if (typeof window !== "undefined") window.location.href = "/login";
      return Promise.reject(error);
    }

    // Network error / wrong baseURL: retry once with backend default.
    // This fixes cases where env points to frontend itself or an old port.
    const cfg = error?.config;
    const hasResponse = !!error?.response;
    const alreadyRetried = !!cfg?._baseRetry;
    const currentBase = api.defaults.baseURL;

    if (!alreadyRetried && !hasResponse && currentBase !== BACKEND_DEFAULT_BASE_URL && process.env.NODE_ENV !== "production") {
      api.defaults.baseURL = BACKEND_DEFAULT_BASE_URL;
      cfg._baseRetry = true;
      return api(cfg);
    }

    return Promise.reject(error);
  }
);

export default api;
